import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const DropzoneMessages = defineMessages({
  title: {
    id: 'src.components.files.Dropzone.title',
    defaultMessage: 'Soubory nahrajete {click} nebo přetáhnutím do této oblasti.',
  },
  byClick: {
    id: 'src.components.files.Dropzone.byClick',
    defaultMessage: 'kliknutím',
  },
  uploadingFiles: {
    id: 'src.components.files.Dropzone.uploadingFiles',
    defaultMessage: 'Nahrávám soubory...',
  },
  loading: {
    id: 'app.0.dictionary.loading',
  },
  deleteConfirmation: {
    id: 'src.components.files.Dropzone.deleteConfirmation',
  },
});
